<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/ion/dice-outline";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.Button v-tooltip.right="'Randomize'" class="p-0!" link @click="$emit('click')">
        <Icon class="text-black hover:cursor-pointer" />
    </PV.Button>
</template>
